module.exports = [
  {
    label: 'Да',
    value: true
  },
  {
    label: 'Нет',
    value: false
  },
  {
    label: 'Нет данных',
    value: null
  }
]
